import { lazy, Suspense, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import {
  getOnboardingStateKey,
  useOnboardingState,
} from '@/features/onboarding';

import type { OnboardingState } from '@/features/onboarding';

const OnboardingFlow = lazy(() => import('@/components/OnboardingFlow'));

const OnboardingSurfaces = () => {
  const queryClient = useQueryClient();
  const { data } = useOnboardingState();

  const handleClose = useCallback(
    (categories: string[]) => {
      queryClient.setQueryData<OnboardingState>(
        getOnboardingStateKey(),
        (current) => ({
          shouldShow: false,
          categories,
          fileId: current?.fileId ?? null,
          deck: [],
        })
      );
    },
    [queryClient]
  );

  if (!data?.shouldShow) return null;

  return (
    <Suspense fallback={null}>
      <OnboardingFlow
        fileId={data.fileId}
        deck={data.deck}
        onClose={handleClose}
      />
    </Suspense>
  );
};

export default OnboardingSurfaces;
